import React from "react";
import Checkbox from "@visiblethread/react-components/dist/components/Checkbox";
import { checkedTypes } from "constants/types";
import PropTypes from "prop-types";
import { folderBy, itemProps } from "layout/dictionarySearch/constants";
import { setItemCheckState } from "slices/dictionarySearch/dictionarySearchSlice";
import { useDispatch, useSelector } from "react-redux";
import Gradient from "components/Gradient";
import { ReactComponent as Wildcard } from "icons/dictionary/Wildcard.svg";
import { ReactComponent as CaseSensitive } from "icons/dictionary/CaseSensitive.svg";
import { ReactComponent as Regex } from "icons/dictionary/Regex.svg";
import {
  dictionaryDefaultColour,
  dictionaryTermTypes,
} from "constants/dictionary";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";

const Item = ({ item, maxOccurrences, docId }) => {
  const hasOccurrences = item.occurrences !== undefined && item.occurrences > 0;
  const by = useSelector((state) => state.dictionarySearch.config.folderBy);
  const dispatch = useDispatch();
  const handleCheck = () => {
    const newState =
      item.checkState === undefined || item.checkState === checkedTypes.EMPTY
        ? checkedTypes.CHECKED
        : checkedTypes.EMPTY;
    dispatch(
      setItemCheckState({ index: item.index, checkedState: newState, docId })
    );
  };

  const frequency = () => {
    if (!hasOccurrences) {
      return null;
    }
    return by === folderBy.folder ? (
      <span>{item.occurrences}</span>
    ) : (
      <Gradient content={item.occurrences} maxOccurrences={maxOccurrences} />
    );
  };

  const itemName = () => (
    <TooltipTrigger content={item.description}>
      <span className="item__text__name">{item.name}</span>
    </TooltipTrigger>
  );

  const itemCheckbox = () => (
    <Checkbox
      state={
        item.occurrences
          ? item.checkState || checkedTypes.EMPTY
          : checkedTypes.EMPTY
      }
      handleChange={handleCheck}
      disabled={!item.occurrences}
      id="item_cb"
      value="item_cb"
    />
  );

  const colour = () => (
    <div
      className={`item__colour${!hasOccurrences ? " disabled" : ""}`}
      data-testid="item-colour"
      style={{ background: item.colour }}
    />
  );

  const iconWithTooltip = (icon, tooltipText) => (
    <TooltipTrigger content={tooltipText}>
      <span className={`item__text__icon${!hasOccurrences ? " disabled" : ""}`}>
        {icon}
      </span>
    </TooltipTrigger>
  );

  const caseSensitiveIcon = () =>
    iconWithTooltip(<CaseSensitive />, "Case Sensitive");
  const wildCardIcon = () => iconWithTooltip(<Wildcard />, "Wildcard");
  const regexIcon = () => iconWithTooltip(<Regex />, "Regex");

  return (
    <div
      className={`item${!hasOccurrences ? " greyed" : ""}`}
      data-testid="category-item"
    >
      <div className="item__text">
        {itemCheckbox()}
        <span className="item__text__name_wrapper">{itemName()}</span>
        {item.colour !== dictionaryDefaultColour && colour()}
        {item.caseSensitive && caseSensitiveIcon()}
        {item.dictionaryTermType === dictionaryTermTypes.WILDCARD_EXPRESSION &&
          wildCardIcon()}
        {item.dictionaryTermType === dictionaryTermTypes.REGULAR_EXPRESSION &&
          regexIcon()}
      </div>
      <div className="item__frequency">{frequency()}</div>
    </div>
  );
};

export default Item;

Item.propTypes = {
  item: PropTypes.shape(itemProps).isRequired,
  maxOccurrences: PropTypes.number,
  docId: PropTypes.number,
};
